import {type MutationTree} from 'vuex';

const mutations: MutationTree<TelephoneToolbarState> = {
    setInitialised(state, status)
    {
        state.initialized = status;
    },
    setLastUpdate(state, date)
    {
        state.lastUpdate = date;
    },
    setSettings(state, settings)
    {
        state.settings = settings;
    },
    setEmployees(state, employees)
    {
        state.employees = employees;
    },
    setOpen(state, open)
    {
        state.open = open;
    },
    setOpenRequestCount(state, count: number)
    {
        state.openRequestCount = count;
    },
    decreaseOpenRequestCount(state, amount: number = 1)
    {
        state.openRequestCount -= amount;
    },
};

export default mutations;